import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    dataUser: {},
    canPlay: false,
    session: null,
    bell: {
      status: false
    },

    modalOflline: false,
    showNotification: false
  },

  mutations: {
    logout(state) {
      state.dataUser = {};
      localStorage.clear();
      sessionStorage.clear();
    },

    setBell(state, data) {
      state.bell = { status: !!data };
    }
  },
  actions: {
  },
  modules: {
  }
})
